import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
// import PropTypes from "prop-types";
import * as paperBinActions from "../actions/paperBinActions";
import StateManager from "../../shared/utils/StateManager";
import {I18nUtils} from "../../../i18n/I18nUtils";
import MachinesTab from "../../shared/components/tabs/machines/MachinesTab";

class PaperBinTabMachines extends React.Component {

  static TAB_ID = 'machines';

  constructor(init) {
    super(init);

    this.recoverMachine = this.recoverMachine.bind(this);
  }

  recoverMachine(machine){
    this.props.paperBinActions.recoverMachine(machine);
  }

  static renderTabHeader() {
    return (
      <li role="presentation" className="">
        <a href={'#' + this.TAB_ID} data-toggle="tab" aria-expanded="true">{I18nUtils.tr('TR_MAQUINARIA').toUpperCase()}</a>
      </li>
    );
  }

  render() {
    return (
      <div role="tabpanel" className="tab-pane fade" id={PaperBinTabMachines.TAB_ID}>
        <MachinesTab
          id={StateManager.PAPER_BIN_TAB_MACHINES}
          title={I18nUtils.tr('TR_RECUPERAR_MAQUINARIA')}
          action={this.recoverMachine}
          actionText={I18nUtils.tr('TR_RECUPERAR')}
          showOutsource={true}
          showDeleted={true}
        />
      </div>
    );
  }

}

const mapDispatchToProps = dispatch => ({
  paperBinActions: bindActionCreators(paperBinActions, dispatch),
});

export default connect(null, mapDispatchToProps)(PaperBinTabMachines)

PaperBinTabMachines.propTypes = {
};

PaperBinTabMachines.defaultProps = {
};



// WEBPACK FOOTER //
// ./src/app/paperbin/components/PaperBinTabMachines.js